/**
 * Coupons: what a code may look like, and the shapes the admin reads and
 * writes. `worker/migrations/0019_coupons.sql` holds the same limits as
 * CHECKs, and `worker/test/schema/constants.test.ts` holds the two together.
 */
export const COUPON_CODE_MIN_LENGTH = 4;
export const COUPON_CODE_MAX_LENGTH = 32;
export const COUPON_MAX_PCT = 90;
export const COUPON_NOTE_MAX_LENGTH = 200;
const CODE_RE = /^[A-Z0-9-]+$/;
/**
 * A code as typed, read the one way: trimmed and upper-cased, so `summer-10`
 * and `SUMMER-10 ` are one coupon. Null for anything that cannot be one.
 */
export function normalizeCouponCode(typed) {
    if (typeof typed !== "string")
        return null;
    const code = typed.trim().toUpperCase();
    const fits = code.length >= COUPON_CODE_MIN_LENGTH &&
        code.length <= COUPON_CODE_MAX_LENGTH &&
        CODE_RE.test(code);
    return fits ? code : null;
}
/**
 * Most generated codes one write makes: each is a statement in one batch,
 * and a batch that large is already a long write on the order table's
 * database.
 */
export const MAX_COUPONS_PER_WRITE = 200;
//# sourceMappingURL=coupons.js.map